import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button, Card } from 'antd';
import UserStatusType from "../../../enums/UserStatusType";
import HasPermissions from "../../../../../containers/HasPermissions";
import { isUserMultiTenant, userHasPermission } from "../../../../../swzutils/UserPermissionsUtil";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import PaginatedFilterableTable, {} from "../../../components/table/PaginatedFilterableTable";
import { TENANT_EDIT_ACTIVE_TAB_KEY_PARAM_NAME, TenantEditTabKeyEnum } from "./TenantEditForm";
import { useAppSelector } from "../../../../../store";
import { loggedInUserSelector } from "../../../../../store/slice/auth";
const TabApiKeys = ({ tenantId }) => {
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const tableRef = React.useRef(null);
    const backUrl = `/app/tenants/edit/${tenantId}?${TENANT_EDIT_ACTIVE_TAB_KEY_PARAM_NAME}=${TenantEditTabKeyEnum.API_KEYS}`;
    const columns = [{
            title: 'Profile',
            dataIndex: ['tenant', 'name'],
            sorter: false,
            width: '10%',
            condition: isUserMultiTenant(loggedInUser)
        }, {
            title: 'Username',
            dataIndex: 'username',
            sorter: true,
            width: '20%'
        }, {
            title: 'Description',
            dataIndex: 'description',
            width: '40%'
        }, {
            title: 'Status',
            dataIndex: 'status',
            width: '20%',
            render: (text /*, record*/) => {
                return UserStatusType.valueOf(text)?.renderTag();
            }
        }, {
            title: 'Action',
            key: 'action',
            width: '20%',
            condition: userHasPermission(loggedInUser, ['admin:apiKey:update']),
            render: (text, record) => {
                return (_jsx("span", { className: "actions", children: _jsx(Button, { href: `#/app/api-keys/edit/${record.id}?backUrl=${backUrl}`, icon: _jsx(EditOutlined, {}), children: "Edit" }) }));
            }
        }];
    return (_jsxs(Card, { title: "API Keys", type: "inner", variant: 'borderless', children: [_jsx("div", { className: "table-operations-inline", children: _jsx(HasPermissions, { permissions: ['admin:apiKey:create'], children: _jsx(Button, { href: `#/app/api-keys/edit/new?backUrl=${backUrl}`, icon: _jsx(PlusOutlined, {}), children: "Add an API Key" }) }) }), _jsx(PaginatedFilterableTable, { tableKey: 'apiKeysTable', ref: tableRef, dataUri: "/admin/v1/users?userType=API", columns: columns, refreshOnSelectedTenantChanged: false, filterTenantId: tenantId })] }));
};
export default TabApiKeys;
